import React from "react";
import Popover from "~/common/Popover";
export default ({
  type
}: {
  type: string;
}) => <Popover title="Why don't we show the price for this item?" triggerElement={(ref: React.RefObject<HTMLAnchorElement>) => <p className="why mt-2 mb-3">
        <a href="##" ref={ref} onClick={e => e.preventDefault()}>
          <i className="icon-question" /> Why do we do this?
        </a>
      </p>}>
    Some manufacturers do not like it when we sell their products below their
    required minimums. In order to offer you the best possible deal, we ask that
    you simply{" "}
    {type === "contact" ? "contact us to find out our great price!" : "place the item in your shopping cart to see our great price!"}
  </Popover>;